export default "__VITE_ASSET__a0073a23__"